// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jivosite_jivo-hidden__YKveJ jdiv {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/plugins/Jivosite/Jivosite.module.scss"],"names":[],"mappings":"AACE;EACE,wBAAA;AAAJ","sourcesContent":[".jivo-hidden {\n  & jdiv {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"jivo-hidden": `Jivosite_jivo-hidden__YKveJ`
};
export default ___CSS_LOADER_EXPORT___;
